export const contractTypeEnum = {
    PERMANENT: 1,
    FIXED_TERM: 2,
    APPRENTICE: 3,
    TEMPWORKER: 4,
    INTERN: 5,
    SUBCONTRACTOR: 6,
    OTHER: 20,
};

export const specialUserTypeEnum = {
    USER: 1,
    SITE: 2,
    TRUCK: 3,
    AMPLIROLL: 4,
    HEAVYTRANSPORTER: 5,
};
